function alertMessage(status){
    if(status){
        if(status.type==='S'){
            alert(status.message);
        }else if(status.type==='E'){
            alert(status.message);
        }
    }
}
export default alertMessage;